<template>
  <div>
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer align-middle pl-3 mt-1"
    >
      <vs-icon icon-pack="speakol" icon="speakol-dots" class="adset-icon"/>
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 11rem;">
          <router-link @click="$gtag.event('Campaigns_edit_action')" :to="{ name: 'campaigns-edit', params: { id: campaign.id } }">
            <li
              id="campaigns-table-edit-button"
              v-if="$canAny('edit_personal_campaigns', 'edit_all_campaigns') && campaign.version === 'v3'"
              class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 text-black hover:text-black"
            >
              <vs-icon icon-pack="speakol" icon="speakol-edit" svgClasses="w-5 h-5"/>
              <span class="ml-2">{{ $t("Edit") }}</span>
            </li>
          </router-link>

          <router-link @click="$gtag.event('Campaigns_dublicate_action')" :to="{ name: 'campaigns-duplicate', params: { duplicate: campaign.id } }">
            <li
              id="campaigns-table-duplicate-button"
              v-if="$can('create_campaigns') && campaign.version === 'v3'"
              class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 text-black hover:text-black"
            >
              <vs-icon icon-pack="speakol" icon="speakol-copy" svgClasses="w-5 h-5"/>
              <span class="ml-2">{{ $t("Duplicate") }}</span>
            </li>
          </router-link>

          <router-link @click="$gtag.event('Campaigns_insights_action')" :to="{ name: 'campaigns-insights', params: { id: campaign.id } }">
            <li
              id="campaigns-table-insights-button"
              v-if="$can('campaign_insights')"
              class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 text-black hover:text-black"
            >
              <vs-icon icon-pack="speakol" icon="speakol-activity" svgClasses="w-5 h-5"/>
              <span class="ml-2">{{ $t("Insights") }}</span>
            </li>
          </router-link>

          <router-link v-if="showTrackingAction" @click="$gtag.event('Campaigns_tracking_action')" :to="{ path: '/conversions', query: { id: campaign.id } }">
            <li
              id="campaigns-table-tracking-button"
              v-if="$can('campaign_tracking')"
              class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 text-black hover:text-black"
            >
              <vs-icon icon-pack="speakol" icon="speakol-trending" svgClasses="w-5 h-5"/>
              <span class="ml-2">{{ $t("Tracking") }}</span>
            </li>
          </router-link>

          <a class="text-black" @click.prevent="canDeleteCampaign(campaign.id)" href="">
            <li
              id="campaigns-table-delete-button"
              v-if="canDelete"
              class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 text-danger"
            >
              <vs-icon
                :icon="'speakol-delete'"
                :color="'#DB2828'"
                icon-pack="speakol"
              >
              </vs-icon>
              <span class="pl-1">{{ $t("Delete") }}</span>
            </li>
          </a>

        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <speakol-confirmation-popup
      v-on:hide-confirmation-popup="deletionConfirmationPopup.show = false"
      v-on:confirm="deleteAction(campaign)"
      :showConfirmationPopup="deletionConfirmationPopup.show"
      :title="deletionConfirmationPopup.title"
      :htmlBody="deletionConfirmationPopup.htmlBody"
      :confirmationText="deletionConfirmationPopup.confirmationText"
    >
    </speakol-confirmation-popup>

    <speakol-response-popup
      v-on:hide-response-popup="deletionErrorPopup.show = false"
      :responsePopupData="deletionErrorPopup"
    />
  </div>
</template>

<script>
export default {
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      deletionConfirmationPopup: {
        show: false,
        title: 'Delete Confirmation',
        htmlBody: ''
      },
      deletionErrorPopup: {
        show: false,
        type: 'error',
        body: ''
      }
    }
  },

  computed: {
    canDelete () {
      const isSystemDeleteEnabled = this.$hasFeature('system-deletes')

      const hasDeletePermission = this.$can('system_deletion')

      return isSystemDeleteEnabled && hasDeletePermission
    },

    showTrackingAction () {
      return this.campaign.objective_id !== this.$constants.CAMPAIGN_OBJECTIVES_IDS.LEAD_FORM
    }
  },

  watch: {
    '$route.fullPath' () {
      this.$destroy()
    }
  },

  methods: {
    async canDeleteCampaign (campaignId) {
      const response = await window.axios.get(`/campaigns/${campaignId}/can-delete`)

      const responsePayload = response.data.payload

      const deleteMsg = this.setDeleteMessage(responsePayload)

      // If he can delete
      if (responsePayload.can) {
        this.deletionConfirmationPopup.show = true
        this.deletionConfirmationPopup.htmlBody = deleteMsg
      } else {
        this.deletionErrorPopup.show = true
        this.deletionErrorPopup.body = deleteMsg
      }
    },

    async deleteAction (campaign) {
      await this.$store.dispatch('campaign/deleteCampaign', campaign)

      this.deletionConfirmationPopup.show = false
    },

    setDeleteMessage (responsePayload) {
      const resMeta = responsePayload.meta

      if (resMeta.reason === 'HAS_INSIGHTS') {
        return 'This campaign has insights. It cannot be deleted.'
      } else if (resMeta.reason === 'NO_INSIGHTS') {
        return `Are you sure you want to delete the <strong>${this.campaign.name}</strong> Campaign?`
      }
    }
  }
}
</script>
